import Header from "./Header";
import Footer from "./Footer";
import React, {useEffect, useState} from "react";
import {faqs} from "../constants/Constants";
import {ChevronDown} from "lucide-react";

const fullHeading = "Frequently Asked Questions";
const smallHeading = "FAQ";

function Faq() {
    const [openIds, setOpenIds] = useState(new Set()); // allow multiple open

    const toggle = (i) => {
        setOpenIds((prev) => {
            const next = new Set(prev);
            next.has(i) ? next.delete(i) : next.add(i);
            return next;
        });
    };
    const [heading, setHeading] = useState(window.innerWidth > 550 ? fullHeading : smallHeading);

    useEffect(() => {
        const updateRadius = () => {
            const width = window.innerWidth;
            if (width > 550) {
                setHeading(fullHeading);
            } else {
                setHeading(smallHeading);
            }
        };
        updateRadius();
        window.addEventListener('resize', updateRadius);
        return () => window.removeEventListener('resize', updateRadius);
    }, []);

    return (
        <div>
            <Header page="faq"/>
            <div className="body">
                <div className={"heading"}>{heading}</div>
                <div className="faqs">
                    {faqs.map((item, i) => {
                        const isOpen = openIds.has(i);
                        const panelId = `faq-panel-${i}`;
                        const btnId = `faq-btn-${i}`;
                        return (
                            <div className={`faq-item ${isOpen ? "open" : ""}`} key={i}>
                                <button
                                    id={btnId}
                                    className="faq-q"
                                    aria-expanded={isOpen}
                                    aria-controls={panelId}
                                    onClick={() => toggle(i)}
                                >
                                    <span className="faq-q-text">{item.question}</span>
                                    <ChevronDown className={`faq-chevron ${isOpen ? "rot" : ""}`} size={18}/>
                                </button>

                                <div
                                    id={panelId}
                                    role="region"
                                    aria-labelledby={btnId}
                                    className="faq-a"
                                    style={{maxHeight: isOpen ? "1000px" : 0}}
                                >
                                    <div className="faq-a-inner">
                                        {item.answer}
                                        {item.answer.includes('read more about 42Degrees') &&
                                            <a href='https://fortytwodegrees.org' target='_blank'
                                               rel='noopener noreferrer'>here.</a>
                                        }
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>

            <Footer page={"faq"}/>
        </div>
    );
}

export default Faq;